var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Map Marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5396 6.07987C10.5396 7.48231 9.40272 8.61921 8.00028 8.61921C6.59784 8.61921 5.46094 7.48231 5.46094 6.07987C5.46094 4.67743 6.59784 3.54053 8.00028 3.54053C9.40272 3.54053 10.5396 4.67743 10.5396 6.07987ZM9.43962 6.07987C9.43962 6.87479 8.7952 7.51921 8.00028 7.51921C7.20535 7.51921 6.56094 6.87479 6.56094 6.07987C6.56094 5.28494 7.20535 4.64053 8.00028 4.64053C8.7952 4.64053 9.43962 5.28494 9.43962 6.07987Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.501 5.61781C13.501 8.21507 9.64643 13.7299 8.39075 15.4576C8.19586 15.7257 7.80511 15.7257 7.61023 15.4576C6.35455 13.7299 2.5 8.21507 2.5 5.61781C2.5 2.51518 4.96265 0 8.00049 0C11.0383 0 13.501 2.51518 13.501 5.61781ZM12.401 5.61781C12.401 6.04146 12.2314 6.70736 11.8645 7.58294C11.5093 8.43082 11.0141 9.37176 10.4668 10.3092C9.61687 11.7649 8.67062 13.1624 8.00049 14.1128C7.33036 13.1624 6.38411 11.7649 5.53418 10.3092C4.98687 9.37176 4.4917 8.43082 4.13643 7.58294C3.76956 6.70735 3.6 6.04146 3.6 5.61781C3.6 3.10069 5.59194 1.1 8.00049 1.1C10.409 1.1 12.401 3.10069 12.401 5.61781Z",
    fill: "#414141"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/MapMarker.416d2dee94e0adb99b3ae48beca81b0e.svg";
export { ForwardRef as ReactComponent };